var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 34,
    viewBox: "0 0 174 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2206_14406)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 8.5,
    r: 8.5,
    fill: "#0061DB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    fill: "#00C791"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 25.5,
    r: 8.5,
    fill: "#8633FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.83984,
    cy: 25.5,
    r: 8.5,
    fill: "#FF1F6A"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M166.884 14.5691C167.405 13.1799 168.258 12.1379 169.445 11.4433C170.661 10.7487 172.006 10.4014 173.483 10.4014V16.653C171.775 16.4504 170.241 16.7977 168.881 17.6949C167.549 18.5921 166.884 20.0827 166.884 22.1666V32.5425H161.283V10.8355H166.884V14.5691Z",
    fill: "#F9FAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M140.79 23.9898C141.542 26.7104 143.583 28.0707 146.911 28.0707C149.053 28.0707 150.674 27.3471 151.773 25.9L156.288 28.5048C154.147 31.6017 150.992 33.1501 146.824 33.1501C143.235 33.1501 140.355 32.0648 138.185 29.8941C136.014 27.7234 134.929 24.9883 134.929 21.6888C134.929 18.4183 136 15.6977 138.141 13.527C140.283 11.3274 143.033 10.2275 146.39 10.2275C149.574 10.2275 152.193 11.3274 154.248 13.527C156.332 15.7266 157.374 18.4472 157.374 21.6888C157.374 22.4124 157.301 23.1794 157.157 23.9898H140.79ZM140.703 19.6484H151.773C151.455 18.1723 150.789 17.0725 149.776 16.3489C148.792 15.6253 147.663 15.2636 146.39 15.2636C144.885 15.2636 143.64 15.6543 142.656 16.4357C141.672 17.1882 141.021 18.2591 140.703 19.6484Z",
    fill: "#F9FAFB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125.331 32.5423V0.850098H130.931V32.5423H125.331Z",
    fill: "#F9FAFB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112.557 33.1501C109.286 33.1501 106.551 32.0503 104.352 29.8507C102.181 27.651 101.096 24.9304 101.096 21.6888C101.096 18.4472 102.181 15.7266 104.352 13.527C106.551 11.3274 109.286 10.2275 112.557 10.2275C114.67 10.2275 116.594 10.734 118.331 11.747C120.068 12.76 121.385 14.1203 122.282 15.8279L117.463 18.6498C117.029 17.7526 116.363 17.0435 115.466 16.5226C114.597 16.0016 113.613 15.7411 112.514 15.7411C110.835 15.7411 109.446 16.3055 108.346 17.4343C107.246 18.5341 106.696 19.9523 106.696 21.6888C106.696 23.3964 107.246 24.8146 108.346 25.9434C109.446 27.0432 110.835 27.5931 112.514 27.5931C113.642 27.5931 114.641 27.3471 115.509 26.8551C116.406 26.3341 117.072 25.625 117.506 24.7278L122.369 27.5063C121.413 29.2139 120.068 30.5887 118.331 31.6306C116.594 32.6436 114.67 33.1501 112.557 33.1501Z",
    fill: "#F9FAFB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1561 14.5691C93.677 13.1799 94.5308 12.1379 95.7175 11.4433C96.9331 10.7487 98.2789 10.4014 99.755 10.4014V16.653C98.0474 16.4504 96.5134 16.7977 95.1531 17.6949C93.8217 18.5921 93.1561 20.0827 93.1561 22.1666V32.5425H87.5557V10.8355H93.1561V14.5691Z",
    fill: "#F9FAFB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6074 8.23046C78.6813 8.23046 77.8709 7.89762 77.1763 7.23194C76.5106 6.53731 76.1777 5.72692 76.1777 4.80075C76.1777 3.87459 76.5106 3.0642 77.1763 2.36957C77.8709 1.67495 78.6813 1.32764 79.6074 1.32764C80.5625 1.32764 81.3729 1.67495 82.0386 2.36957C82.7332 3.0642 83.0806 3.87459 83.0806 4.80075C83.0806 5.72692 82.7332 6.53731 82.0386 7.23194C81.3729 7.89762 80.5625 8.23046 79.6074 8.23046ZM76.8289 32.5423V10.8353H82.4293V32.5423H76.8289Z",
    fill: "#F9FAFB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0029 33.1503C55.4299 33.1503 51.6529 31.6308 48.6718 28.5918C45.6907 25.5528 44.2002 21.8048 44.2002 17.3476C44.2002 12.8615 45.6907 9.11342 48.6718 6.10339C51.6529 3.06441 55.4299 1.54492 60.0029 1.54492C62.7524 1.54492 65.2849 2.19613 67.6003 3.49855C69.9447 4.77203 71.7681 6.50859 73.0705 8.70823L67.9042 11.7038C67.1517 10.3435 66.0808 9.28708 64.6916 8.53457C63.3023 7.75312 61.7394 7.36239 60.0029 7.36239C57.0507 7.36239 54.663 8.28856 52.8396 10.1409C51.0451 11.9932 50.1479 14.3955 50.1479 17.3476C50.1479 20.2708 51.0451 22.6586 52.8396 24.5109C54.663 26.3632 57.0507 27.2894 60.0029 27.2894C61.7394 27.2894 63.3023 26.9132 64.6916 26.1606C66.1098 25.3792 67.1807 24.3228 67.9042 22.9914L73.0705 25.987C71.7681 28.1866 69.9592 29.9377 67.6437 31.2401C65.3283 32.5135 62.7814 33.1503 60.0029 33.1503Z",
    fill: "#F9FAFB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2206_14406"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkLogo);
export default __webpack_public_path__ + "static/media/DarkLogo.02b7347a5b63da0b961e0e8e227613b2.svg";
export { ForwardRef as ReactComponent };